/*global jQuery */
jQuery(document).ready(($) => {
	'use strict';

	// Masonry Grid JS
	function resizeGridItem(item) {
		const grid = document.getElementsByClassName(
			'glossary-card--listing',
		)[0];
		const rowHeight = parseInt(
			window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'),
			10,
		);
		const rowGap = parseInt(
			window.getComputedStyle(grid).getPropertyValue('grid-row-gap'),
			10,
		);
		const rowSpan = Math.ceil(
			(item
				.querySelector(
					'.glossary-card--item:not(.inactive) .card__content',
				)
				.getBoundingClientRect().height +
				rowGap) /
				(rowHeight + rowGap),
		);
		item.style.gridRowEnd = `span ${rowSpan + 1}`;
	}

	// Filter Glossary items
	function initGlossaryFilter() {
		// Filter using navigation
		$('.glossary__nav a').click(function handleGlossaryClick() {
			const nav = $(this).attr('data-nav');

			// Remove & Add active class
			$('.glossary__nav__item').removeClass('active');
			$(this).parent().toggleClass('active');

			// Hide all the results
			$('.glossary-card--item').addClass('inactive');

			// Loop through the row
			$('.glossary-card--item').each(function removeInactiveClass() {
				const term = $(this).attr('data-term');
				if (nav === term) {
					$(this).removeClass('inactive');
				}
				if (nav === '*') {
					$('.glossary__nav__item').addClass('active');
					$('.glossary-card--item').addClass('active');
					$('.glossary__nav__item').removeClass('inactive');
					$('.glossary-card--item').removeClass('inactive');
				}
			});

			// Only return false if data-toggle is glossary
			if ($(this).attr('data-toggle') === 'glossary') {
				return false;
			}

			return true;
		});
	}

	// Filter Results from Buttons vvv
	$(() => {
		initGlossaryFilter();
	});

	function firstLetterSelection(item) {
		const letter = item.attributes['data-item'].value.charAt();
		$(item).attr('data-term', letter);
	}

	// Add data-term hook for filtering
	const gArray = document.getElementsByClassName('glossary-card--item');
	const glossary = Array.from(gArray);
	glossary.forEach(firstLetterSelection);

	// Generate Floating Alphabet vvv
	const terms = $('div.glossary-card--item h3.card__title').sort();

	const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	for (let i = 0; i < letters.length; i++) {
		const nextChar = letters.charAt(i);

		// Need to find first of each letter
		const notFound = -999;
		let foundOne = notFound;
		for (let j = 0; j < terms.length; j++) {
			const termj = terms[j].innerText;
			const termJJ = termj.toUpperCase();
			if (termJJ.charAt(0) === nextChar) {
				foundOne = j;
				break;
			}
		}

		// Create links and anchors based on whether something was found
		let newLetterLink;
		if (foundOne === notFound) {
			// Create a new letterLink (with class "entriesAbsent")
			newLetterLink = `<span class="letterLinkSpan"><a class="letterLink entriesAbsent">${nextChar}</a></span>`;
		} else {
			// Create a new letterLink (with class "entriesPresent")
			newLetterLink = `<span class="letterLinkSpan glossary__nav__item"><a class="letterLink entriesPresent" href="#" data-nav="${nextChar}" data-toggle="glossary">${nextChar}</a></span>`;

			// Create an anchor for the letterLink BEFORE the first glossary term starting with that letter
			$(`<a class="letterAnchor" name="${nextChar}">`).insertBefore(
				terms[foundOne],
			);
		}

		// Either way, add the letterLink to the list of letterLinks
		$('div#quicklinks').append(newLetterLink);
	}
	// Sort Alphabetically Asc.
	function ascSort(a, b) {
		return $(b).text() < $(a).text() ? 1 : -1;
	}
	$('.glossary-card--item').sort(ascSort).appendTo('#glossary');

	function resizeAllGridItems() {
		const allItems = document.getElementsByClassName('glossary-card--item');
		let x = Array.from(allItems);
		for (x = 0; x < allItems.length; x++) {
			resizeGridItem(allItems[x]);
		}
	}
	window.onload = resizeAllGridItems();
	window.addEventListener('resize', resizeAllGridItems);

	$('.definition').each(function removeNonBreakingSpaces() {
		$(this).html(
			$(this)
				.html()
				.replace(/&nbsp;/gi, ' '),
		);
	});
});
